import React, { useState,useRef } from "react";
import { Card } from "antd";
import { useNavigate } from "react-router-dom";
import useResumeStore from "../../store/resume.store";
import RDBTable from "../RDBTable";
import "./resumeResultsCard.scss";


export default function ResumeResultsApplicationViewCard({
   jdClickHandler,
   jdList,
   resume,
   applications
}) {
    const navigate = useNavigate();
    const inputRef = useRef(null);
    const { allApplications} =
        useResumeStore();
    const foundListTable = [
        "Sr. No.",
        "JD ID",
        "JD",
        "Resume Suitablity",
        "Candidate Status",       
        "Resume Status",
        "Interview Status",  
        "Selection Status",
        "Document Status",
        "BGV Status",
        "Current CTC",        
        "ECTC",
        "Offered CTC",
        "DoJ",
        "Updated By",
        "Updated On",
        "Ownership",
    ]; 

    // Function to get title by jdid
    const getTitleByJdid = (jdid) => {
        const match = jdList.find(item => item.startsWith(jdid));
        if (!match) return null; // not found
        const parts = match.split("/");
        return parts[1] ? parts[1].trim() : "";
    };
    function formatUnixDate(ts) {
        const d = new Date(ts * 1000);
        const mm = String(d.getMonth() + 1).padStart(2, "0");
        const dd = String(d.getDate()).padStart(2, "0");
        const yyyy = d.getFullYear();

        return `${dd}-${mm}-${yyyy}`;
    }   
        

    const foundAppsData = applications?.map((appDetail, idx) => { 
        return {
            id: idx+1,
            jdId:  appDetail?.qhcompanyjid,
            jdTitle: getTitleByJdid(appDetail?.qhcompanyjid),
            resumeSuitability: appDetail?.resumescore?.scorestr,
            candidateStatus: appDetail?.candidatestatus?.status?appDetail?.candidatestatus?.status:"--",
            resumeStatus: appDetail?.resumestatus?.status?appDetail?.resumestatus?.status:"--",
            interviewStatus: appDetail?.interviewstatus?.status?appDetail?.interviewstatus?.status:"--",
            sStatus: appDetail?.selectionstatus?.status?appDetail?.selectionstatus?.status:"--",
            dStatus: appDetail?.documentsstatus?.status?appDetail?.documentsstatus?.status:"--",
            bgvStatus: appDetail?.bgvstatus?.status?appDetail?.bgvstatus?.status:"--",
            cCTC: resume?.employmentdetails.currentctc?.totalctc,
            eCTC: appDetail?.newemploymentdetails?.ectc?.totalctc,
            oCTC: appDetail?.newemploymentdetails?.octc?.totalctc,
            eDoJ: appDetail?.newemploymentdetails?.finaldoj,            
            updatedBy:appDetail?.updatedby?.name,
            updatedOn:formatUnixDate(appDetail?.timestamp),
            ownership: resume?.firstuploadedby.method ,
        };
    });       

    return (
        <div className="resumeResultsCard-application-wrapper">
            <Card title= {<span style={{margin:"15px",fontWeight: "400",fontSize:"12px" }}>
                                            [ {resume?.qhrid} ] {resume?.personaldetail?.name}
                                         </span>} >
                <RDBTable
                    isClickable = {true}
                    jdClickHandler = {jdClickHandler}
                    selectedResumeID ={resume?.qhrid}
                    titleList={foundListTable}
                    data={foundAppsData}
                    emptyString = {"No Appliations Found"}
                    columnWidth={`50px 2fr 3fr 2fr 2fr 2fr 2fr 2fr 2fr 2fr  2fr 2fr 2fr 2fr 2fr 2fr 2fr`}
                />                                
            </Card>                                                       
        </div>
    );
}
